import React from 'react'

export default function NewsItem(props) {

   let { title, description, imageurl, newsUrl } = props;
   return (
      <>
         <div className="col-md-4 col-sm-6 my-2">
            <div className="card" >
               <img src={imageurl} className="card-img-top" alt="..." />
               <div className="card-body">
                  <h5 className="card-title text-90">{title.length > 80 ? (title.slice(0, 80) + "...") : title}</h5>

                  <p className="card-text text-90">{description.length > 60 ? (description.slice(0, 60) + "...") : description}</p>
                  {/* 
                     <a href="/newsdetails" target='_blank' className="btn btn-sm btn-primary px-2 mx-1 my-1">Details</a> */}

                  <a href={newsUrl} target='_blank' rel="noreferrer" className="btn btn-sm btn-dark px-2 mx-1 my-1">Read More</a>
               </div>
            </div>
         </div >
      </>
   )
}


